import React from 'react';
import { XIcon } from 'lucide-react';
const costs = ['Oltre 150 ore perse a decidere "cosa cucinare stasera" con il frigorifero pieno.', 'Centinaia di euro buttati in cibi pronti che ti infiammano e ti fanno sentire pesante.', 'Energia zero: quel senso di gonfiore costante che rovina le tue giornate e il tuo umore.', 'Frustrazione totale: provare diete restrittive che falliscono dopo solo una settimana.'];
export function PainSection() {
  return <section className="py-6 sm:py-12 px-4 bg-brand-cream" data-id="element-88">
      <div className="max-w-xl mx-auto" data-id="element-89">
        <h2 className="text-xl sm:text-3xl font-serif font-bold text-center mb-2 sm:mb-3 text-brand-text-main" data-id="element-90">
          Smetti di pagare con il tuo tempo e la tua salute.
        </h2>

        <p className="text-base sm:text-lg text-center text-brand-text-muted font-medium mb-4 sm:mb-6" data-id="element-91">
          Quanto ti costa ogni anno continuare a rimandare il tuo benessere?
        </p>

        <div className="space-y-2.5 sm:space-y-3" data-id="element-92">
          {costs.map((cost, i) => <div key={i} className="flex gap-3 items-start bg-white p-4 sm:p-5 rounded-xl border border-brand-sage/30" data-id="element-93">
              <div className="mt-0.5 bg-red-500/10 p-1.5 rounded-full shrink-0" data-id="element-94">
                <XIcon className="w-4 h-4 text-red-600" strokeWidth={3} data-id="element-95" />
              </div>
              <p className="text-sm sm:text-base text-brand-text-main font-medium leading-snug" data-id="element-96">
                {cost}
              </p>
            </div>)}
        </div>

        <p className="text-center text-base sm:text-lg font-bold text-brand-olive mt-5 sm:mt-7 italic" data-id="element-97">
          La soluzione non è mangiare meno. È resettare il tuo sistema con
          l'Antinfiammatorio Naturale Mediterraneo.
        </p>
      </div>
    </section>;
}